import { createRouter, createWebHashHistory } from "vue-router";
import { reportPageView } from "../utils/ipTracker";
import Layout from "../views/Layout.vue";
import Home from "../views/Home.vue";
import SchoolList from "../views/SchoolList.vue";
import SubjectList from "../views/SubjectList.vue";
import MockList from "../views/MockList.vue";
import GrowthList from "../views/GrowthList.vue";
import NewsList from "../views/NewsList.vue";
import NewsDetail from "../views/NewsDetail.vue";
import Require from "../views/Require.vue";
import Company from "../views/Company.vue";
import Class from "../views/Class.vue";
import Student from "@/views/Student.vue";
import SchoolDetail from "@/views/SchoolDetail.vue";
import Test from "@/views/Test.vue";
import Process from "@/views/Process.vue";
import Questions from "@/views/Questions.vue";
import UserCenter from "@/views/UserCenter.vue";
import Condition from "@/views/Condition.vue";
import Questions2 from "@/views/Questions2.vue";
import Choose from "@/views/Choose.vue";
import CourseVideoDetail from "@/views/CourseVideoDetail.vue";
import WinterCamp from "../views/WinterCamp.vue";
import Drone from "../views/Drone/Drone.vue";
import VolunteerPlanning from "../views/VolunteerPlanning.vue";
import AIMilitaryInterview from "../views/AIMilitaryInterview.vue";
import RankQuery from "../views/RankQuery.vue";
import ExpertConsultation from "../views/ExpertConsultation.vue";
import NewsCenter from "../views/NewsCenter.vue";
import NewsCenterDetail from "../views/NewsCenterDetail.vue";
import GeneralTools from "../views/GeneralTools.vue";
import ServicePlanning from "../views/ServicePlanning.vue";

import CareerDevelopment from "../views/CareerDevelopment.vue";
import FemaleApplicant from "../views/FemaleApplicant.vue";
import PhysicalStandard from "../views/PhysicalStandard.vue";
import PoliticalReview from "../views/PoliticalReview.vue";
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      { path: "", name: "Home", component: Home, meta: { pageName: "home" } },
      { path: "schools", name: "SchoolList", component: SchoolList, meta: { pageName: "school_list" } },
      { path: "subjects", name: "SubjectList", component: SubjectList, meta: { pageName: "subject_list" } },
      { path: "mocks", name: "MockList", component: MockList, meta: { pageName: "mock_list" } },
      { path: "growths", name: "GrowthList", component: GrowthList, meta: { pageName: "growth_list" } },
      { path: "/", name: "NewsList", component: NewsList, meta: { pageName: "news_list" } },
      { path: "/news/detail/:id", name: "NewsDetail", component: NewsDetail, meta: { pageName: "news_detail" } },
      { path: "/condition", redirect: "/schools" },
      { path: "/require", redirect: "/schools" },
      { path: "/student/:id", name: "Student", component: Student, meta: { pageName: "student_detail" } },
      { path: "/company", name: "Company", component: Company, meta: { pageName: "company" } },
      { path: "/class", name: "Class", component: Class, meta: { pageName: "class" } },
      {
        path: "/school/detail/:id",
        name: "SchoolDetail",
        component: SchoolDetail,
        meta: { pageName: "school_detail" }
      },
      { path: "/test", name: "Test", component: Test, meta: { pageName: "test" } },
      { path: "/process", redirect: "/schools" },
      { path: "/questions", name: "Questions", component: Questions, meta: { pageName: "questions" } },
      { path: "/questions2", name: "Questions2", component: Questions2, meta: { pageName: "questions2" } },
      {
        path: "/usercenter",
        name: "UserCenter",
        component: UserCenter,
        meta: { requiresAuth: true, pageName: "user_center" },
      },
      { path: "/choose", name: "Choose", component: Choose, meta: { pageName: "choose" } },
      {
        path: "/course/:id",
        name: "CourseVideoDetail",
        component: CourseVideoDetail,
        meta: { pageName: "course_detail" }
      },
      { path: "/volunteer-planning", name: "VolunteerPlanning", component: VolunteerPlanning, meta: { pageName: "volunteer_planning" } },
      { path: "/ai-interview", name: "AIMilitaryInterview", component: AIMilitaryInterview, meta: { pageName: "ai_interview" } },
      { path: "/rank-query", name: "RankQuery", component: RankQuery, meta: { pageName: "rank_query" } },
      { path: "/expert-consultation", name: "ExpertConsultation", component: ExpertConsultation, meta: { pageName: "expert_consultation" } },
      { path: "/news-center", name: "NewsCenter", component: NewsCenter, meta: { pageName: "news_center" } },
      { path: "/news-center/detail/:id", name: "NewsCenterDetail", component: NewsCenterDetail, meta: { pageName: "news_center_detail" } },
      { path: "/career-development", name: "CareerDevelopment", component: CareerDevelopment, meta: { pageName: "career_development" } },
      { path: "/female-applicant", name: "FemaleApplicant", component: FemaleApplicant, meta: { pageName: "female_applicant" } },
      { path: "/physical-standard", name: "PhysicalStandard", component: PhysicalStandard, meta: { pageName: "physical_standard" } },
      { path: "/political-review", name: "PoliticalReview", component: PoliticalReview, meta: { pageName: "political_review" } },
      // { path: "/general-tools", name: "GeneralTools", component: GeneralTools, meta: { pageName: "general_tools" } },
      { path: "/service-planning", name: "ServicePlanning", component: ServicePlanning, meta: { pageName: "service_planning" } },
      { path: "/privacy-policy", name: "PrivacyPolicy", component: PrivacyPolicy, meta: { pageName: "privacy_policy" } },
    ],
  },
  {
    path: "/drone",
    name: "Drone",
    component: Drone,
    meta: { requiresAuth: true, pageName: "drone" }
  },
];

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes,
// });
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如浏览器前进/后退）
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则滚动到顶部
      return { top: 0 };
    }
  },
});

// 路由守卫：检查是否需要登录
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const authData = localStorage.getItem("auth");
    let isLoggedIn = false;

    if (authData) {
      try {
        const storedAuth = JSON.parse(authData);
        const authState = storedAuth.state || storedAuth;
        const token = authState._token;
        isLoggedIn = !!token;
      } catch (e) {
        console.error("解析 auth 状态失败", e);
      }
    }

    if (!isLoggedIn) {
      console.log('用户未登录，跳转到首页');
      next({ path: '/' });
    } else {
      next();
    }
  } else {
    next();
  }
});

// 路由跳转成功后自动上报页面浏览
router.afterEach((to) => {
  const pageName = to.meta.pageName || to.name || 'unknown';
  reportPageView(pageName).catch(err => {
    console.error('页面浏览上报失败:', err);
  });
});

export default router;
